export default "__VITE_ASSET__DeDnckQP__"